var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliveryCountry == 1
    ? _c("div", { staticClass: "min-basket-value mb-4 mt-3" }, [
        _vm.percent < 100
          ? _c("div", { staticClass: "text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$translate("Klettershop5::Template.minBasketValueDiff")
                  ) +
                  " " +
                  _vm._s(_vm._f("currency")(_vm.diff)) +
                  "  " +
                  _vm._s(
                    _vm.$translate(
                      "Klettershop5::Template.minBasketValueDiffTextAfter"
                    )
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.percent >= 100
          ? _c("div", { staticClass: "mt-2 text-center color-green" }, [
              _c("i", { staticClass: "fa fa-check-circle-o mr-1" }),
              _vm._v(
                _vm._s(
                  _vm.$translate("Klettershop5::Template.minBasketValueReached")
                ) + "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "progress mt-2" }, [
          _c("div", {
            staticClass: "progress-bar progress-bar-striped bg-success",
            style: "width:" + _vm.percent + "%",
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.percent,
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }
          })
        ]),
        _vm._v("\n\n    " + _vm._s(_vm.percentcalc) + "\n")
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }